import DownloadExcelReport from "@domains/useCases/Reports/common/downloadReport/downloadExcelReport";
import DownloadPDFReport from "@domains/useCases/Reports/common/downloadReport/downloadPdfReport";
import EmailReport from "@domains/useCases/Reports/common/emailReport/emailReport";
import TaxReportUseCase from "@domains/useCases/Reports/Tax/TaxReport";
import ClearTaxUseCase from "@domains/useCases/Reports/Tax/ClearTax";
export default (repositories) => {
    return {
        taxReport: new TaxReportUseCase(repositories.taxMainScreenRepo),
        downloadPDFReports: new DownloadPDFReport(repositories.downloadRepo),
        downloadExcelReports: new DownloadExcelReport(repositories.downloadRepo),
        sendEmailReports: new EmailReport(repositories.downloadRepo),
        clearTax: new ClearTaxUseCase(repositories.taxMainScreenRepo),
    };
};
